// Routes the Guide (/guide) uses, served by src/aithora/v3/guide.ts.
// GET /onboarding/me and PUT /onboarding/me keep only the Care Staff and Family setup
// fields (push test, practice, channel, first message, dates), not the Guide's step ticks,
// so the Guide needs its own per-user store (handoff: "Guide: step ticks ... Backend:
// persist per user and sync with the console Setup checklist").
import { route } from './route';
import { AITHORA_PREFIX } from './prefix';

const A = AITHORA_PREFIX;

/**
 * The signed-in person's ticks on one guide. `done` maps a step's title (as the guide's
 * content names it) to when it was ticked. The server keys it by the session's user; the
 * guide name only picks which of their guides (a Super Admin or Dev may read another
 * role's guide, and ticks there are theirs alone).
 */
export interface GuideProgress {
  real: true;
  guide: string;
  done: Record<string, string>;
  updatedAt: string | null;
}

export type GuideProgressUpdate = { guide: string; step: string; done: boolean } | { guide: string; reset: true };

/** GET /onboarding/guide?guide=: the caller's own ticks on that guide. */
export const guideProgress = route<GuideProgress, { guide: string }>()('GET', `${A}/onboarding/guide`, { honest: true });

/** PUT /onboarding/guide {guide, step, done} or {guide, reset: true}: tick, untick or start over. */
export const guideProgressSave = route<GuideProgress, void, GuideProgressUpdate>()('PUT', `${A}/onboarding/guide`, { honest: true });

/**
 * GET /facts: the facts the Operator and Sales guides may repeat. facilitiesScored is
 * counted from the facility catalog; the rest are the handoff's values unless the owner
 * changed one. `sources` says which, per key.
 */
export interface GuideFactsResponse {
  real: true;
  facilitiesScored?: string;
  facilitiesOpening?: string;
  startMarkets?: string[];
  firstPilots?: string;
  founding?: { cohort: string | number; pilotDays: string | number; code: string; minDaysForResults: string | number };
  team?: { name: string; title: string }[];
  layers?: { l3?: string };
  sources: Record<string, 'catalog' | 'set' | 'default'>;
  updatedAt: string | null;
}
export const guideFacts = route<GuideFactsResponse>()('GET', `${A}/facts`, { honest: true });

export const guideApi = { guideProgress, guideProgressSave, guideFacts } as const;
